export default __webpack_public_path__ + "info-circle-fill.a2ed31d13e694775.svg";